
import {
    GET_MARKETING_INFO_REQUEST,
    GET_MARKETING_INFO_SUCCESS,
    GET_MARKETING_INFO_FAILURE,
    GET_MARKETING_IMGS_REQUEST,
    GET_MARKETING_IMGS_SUCCESS,
    GET_MARKETING_IMGS_FAILURE
} from '../mutationTypes'
import { getMarketingInfo, getMarketingInfoImgs } from '@/models/home'
const state = {
    pageLoading: false,
    params: {}
}

const mutations = {
    [GET_MARKETING_INFO_REQUEST] (state) {
        state.pageLoading = true
    },
    [GET_MARKETING_INFO_SUCCESS] (state, res) {
        state.pageLoading = false
    },
    [GET_MARKETING_INFO_FAILURE] (state) {
        state.pageLoading = false
    },
    [GET_MARKETING_IMGS_REQUEST] (state) {
        state.pageLoading = true
    },
    [GET_MARKETING_IMGS_SUCCESS] (state, res) {
        state.pageLoading = false
    },
    [GET_MARKETING_IMGS_FAILURE] (state) {
        state.pageLoading = false
    },
}

export const actions = {
    async getMarkeTingInfo ({ commit }, params) {
        params = {
            marketing_id: params
        }
        commit(GET_MARKETING_INFO_REQUEST)
        const data = await getMarketingInfo(params)
        commit(GET_MARKETING_INFO_SUCCESS, data)
        return data
    },
    async getMarketingInfoImgs ({ commit }, params) {
        params = {
            marketing_id: params
        }
        commit(GET_MARKETING_IMGS_REQUEST)
        const data = await getMarketingInfoImgs(params)
        commit(GET_MARKETING_IMGS_SUCCESS, data)
        return data
    }
}

export const getters = {

}

export default {
    state,
    mutations,
}
